export const validateEmail = (email: string): RegExpMatchArray | null =>
  String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )

export const validateInputNumber = (inputVal: string | number): number | undefined =>
  inputVal !== '' ? Number(inputVal) : undefined

export const isLegacyFilePath = (inputString: string): boolean => {
  // Modern localized media shares the UUID path and adds the ISO 639-1 locale
  // before the extension: `{uuid}-fr.mp3` is as canonical as `{uuid}.mp3`.
  const pathRegexp =
    /^[a-zA-Z0-9]{2}\/[a-zA-Z0-9]{2}\/[a-zA-Z0-9]{2}\/[a-zA-Z0-9-]{8}-[a-zA-Z0-9-]{4}-[a-zA-Z0-9-]{4}-[a-zA-Z0-9-]{4}-[a-zA-Z0-9-]{12}(?:-[a-z]{2})?\.[a-zA-Z0-9]{3,5}$/
  return !pathRegexp.test(inputString)
}
